import React from 'react';
import './TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>Terms and Conditions</h1>
          <p className="last-updated">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          
          <section>
            <h2>1. Agreement to Terms</h2>
            <p>
              By accessing or using the vCard digital business card platform operated by Any Edge (Pvt) Ltd 
              ("we," "our," or "us"), you agree to be bound by these Terms and Conditions. If you disagree 
              with any part of these terms, you may not access the service.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              vCard is a digital business card platform that allows users to create, customize, and share 
              digital business cards with QR codes. The service includes features such as profile management, 
              service showcases, brochure/flipbook creation, and analytics.
            </p>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <h3>3.1 Account Creation</h3>
            <p>
              To use certain features of our service, you must register for an account. You agree to provide 
              accurate, current, and complete information during registration and to update such information 
              to keep it accurate, current, and complete.
            </p>

            <h3>3.2 Account Security</h3>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and for 
              all activities that occur under your account. You agree to notify us immediately of any 
              unauthorized use of your account.
            </p>
          </section>

          <section>
            <h2>4. Subscription Plans and Payments</h2>
            <h3>4.1 Subscription Tiers</h3>
            <p>We offer the following subscription plans:</p>
            <ul>
              <li><strong>Free:</strong> Limited features, 3 vCards, 2 services</li>
              <li><strong>Premium:</strong> Enhanced features, unlimited vCards and services, brochures</li>
              <li><strong>Enterprise:</strong> All features including custom domains and white-label options</li>
            </ul>

            <h3>4.2 Payment</h3>
            <p>
              Payments are processed securely through PayHere payment gateway. Subscription fees are charged 
              in advance on a monthly or annual basis, as selected by you. All fees are non-refundable 
              except as required by law.
            </p>

            <h3>4.3 Automatic Renewal</h3>
            <p>
              Subscriptions automatically renew unless cancelled before the renewal date. You may cancel 
              your subscription at any time through your dashboard.
            </p>
          </section>

          <section>
            <h2>5. User Content</h2>
            <h3>5.1 Content Ownership</h3>
            <p>
              You retain ownership of all content you upload to our service, including images, text, 
              and documents. By uploading content, you grant us a license to store, display, and 
              distribute your content as necessary to provide the service.
            </p>

            <h3>5.2 Content Restrictions</h3>
            <p>You agree not to upload content that:</p>
            <ul>
              <li>Is illegal, harmful, or violates any laws</li>
              <li>Infringes on intellectual property rights</li>
              <li>Contains malware, viruses, or harmful code</li>
              <li>Is defamatory, obscene, or offensive</li>
              <li>Violates privacy rights of others</li>
            </ul>

            <h3>5.3 Content Removal</h3>
            <p>
              We reserve the right to remove any content that violates these terms or is otherwise 
              objectionable, without prior notice.
            </p>
          </section>

          <section>
            <h2>6. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the service</li>
              <li>Use automated systems to access the service without permission</li>
              <li>Impersonate any person or entity</li>
              <li>Collect or harvest information about other users</li>
            </ul>
          </section>

          <section>
            <h2>7. Intellectual Property</h2>
            <p>
              The service, including its original content, features, and functionality, is owned by 
              Any Edge (Pvt) Ltd and is protected by international copyright, trademark, and other 
              intellectual property laws. You may not copy, modify, or create derivative works of 
              our service without our express written permission.
            </p>
          </section>

          <section>
            <h2>8. Service Availability</h2>
            <p>
              We strive to provide continuous availability of our service but do not guarantee 
              uninterrupted access. The service may be temporarily unavailable due to maintenance, 
              updates, or unforeseen circumstances. We are not liable for any loss or damage 
              resulting from service unavailability.
            </p>
          </section>

          <section>
            <h2>9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Any Edge (Pvt) Ltd shall not be liable for 
              any indirect, incidental, special, consequential, or punitive damages, or any loss 
              of profits or revenues, whether incurred directly or indirectly, or any loss of data, 
              use, goodwill, or other intangible losses resulting from your use of the service.
            </p>
          </section>

          <section>
            <h2>10. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Any Edge (Pvt) Ltd from any claims, damages, 
              losses, liabilities, and expenses (including legal fees) arising from your use of the 
              service, violation of these terms, or infringement of any rights of another.
            </p>
          </section>

          <section>
            <h2>11. Termination</h2>
            <p>
              We may terminate or suspend your account and access to the service immediately, without 
              prior notice, for any breach of these Terms and Conditions. Upon termination, your right 
              to use the service will cease immediately. You may also terminate your account at any 
              time through your dashboard.
            </p>
          </section>

          <section>
            <h2>12. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any time. We will notify 
              users of material changes by posting the updated terms on this page. Your continued 
              use of the service after such changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section>
            <h2>13. Governing Law</h2>
            <p>
              These Terms and Conditions shall be governed by and construed in accordance with the 
              laws of Sri Lanka, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2>14. Contact Information</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <p>
              <strong>Any Edge (Pvt) Ltd</strong><br />
              Email: support@vcardapps.com<br />
              Website: www.vcardapps.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
